import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  stickyScrollBtnVisible: false,
};

const pageSlice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    toggleStickyScrollBtn(state, action) {
      state.stickyScrollBtnVisible = action.payload;
    },
  },
  extraReducers: {},
});

export const {
  reducer: pageReducer,
  actions: { toggleStickyScrollBtn },
} = pageSlice;
